import { LiquidacionCapturaService } from './../../../services/liquidacion-captura.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, ViewChild } from '@angular/core';
import { SuccessModalComponent } from '../../tools/modals/success-modal/success-modal.component';
import { ErrorModalComponent } from '../../tools/modals/error-modal/error-modal.component';
import { ConfirmModalComponent } from '../../tools/modals/confirm-modal/confirm-modal.component';
import {HelpersService} from "../../../services/tools/helpers.service";
import {WarningModalComponent} from "../../tools/modals/warning-modal/warning-modal.component";
import { LiquidacionCapturaMovimientosObraService } from './../../../services/liquidacion-captura-movimientos-obra.service';
declare var $;

@Component({
  selector: 'app-liquidacion-captura-fondo-ahorro',
  templateUrl: './liquidacion-captura-fondo-ahorro.component.html',
  styleUrls: ['./liquidacion-captura-fondo-ahorro.component.scss']
})
export class LiquidacionCapturaFondoAhorroComponent implements OnInit {
  @ViewChild(SuccessModalComponent) successModal: SuccessModalComponent;
  @ViewChild(ErrorModalComponent) errorModal: ErrorModalComponent;
  @ViewChild(ConfirmModalComponent) confirmModal: ConfirmModalComponent;
  @ViewChild(WarningModalComponent) warningModal: WarningModalComponent;

  movimientosObra: any[];
  alterTable: any = 'starting';
  searchText: string = "";
  mostrarListado: boolean = true;
  errors: any = {};
  fechaActual: string;
  fechaInicioLiquidacion: string;
  fechaFinLiquidacion: string;
  processing: any = false;
  changing: boolean = false;
  /* selected */
  liquidacionSelected: any = undefined;
  fondoSelected: any = undefined;
  notasUrl: string;
  movimientosUrl: string;
  defaultImage: string;

  //CL
  private idLiquidacion:any;

  constructor(private liquidacionCapturaMovimientosObraService: LiquidacionCapturaMovimientosObraService,
              private liquidacionCapturaService: LiquidacionCapturaService,
              private helperService: HelpersService,
              private activedRoute: ActivatedRoute,
              private router: Router) {
                this.deleteLiquidacion = this.deleteLiquidacion.bind(this);
                this.sendLiquidacion = this.sendLiquidacion.bind(this);
                this.saveFondo = this.saveFondo.bind(this);
                this.cancelChanges = this.cancelChanges.bind(this);
              }

  ngOnInit() {
    this.getIdLiquidacion();
  }

  startFondo() {
    this.fondoSelected = {
      'idLiquidacion': this.idLiquidacion,
      'aportaciones': this.liquidacionSelected.aportaciones,
      'retiros': this.liquidacionSelected.retiros
    };
  }

  getIdLiquidacion() {
    this.idLiquidacion = this.activedRoute.snapshot.params.id;
    this.notasUrl = '/liquidacion-captura/' + this.idLiquidacion + '/notas-fotografias';
    this.movimientosUrl = '/liquidacion-captura/' + this.idLiquidacion +'/movimientos-obra';
    if (this.idLiquidacion) {
      this.getLiquidacion();
      this.getMovimientosObra();
    } else {
      console.log('dont found id liquidacion');
      this.regresar();
    }
  }

  getLiquidacion() {
    this.liquidacionCapturaService.getLiquidacionByID(this.idLiquidacion)
      .subscribe(response => {
        const content_response = response.json().content;
        this.liquidacionSelected = content_response;
        this.liquidacionSelected.fecha_formated = this.helperService.getMonthYearByDate(this.liquidacionSelected.fechaLiquidacion);
        this.startFondo();
        console.log("datos",this.liquidacionSelected);
      }, error => {
        const content_error = error.json().content;
        // resuelve errores 403, 500 y sin internet
        this.helperService.httpGlobalError(error);

        if (error.status == 400 && content_error.id) {
          this.router.navigate(['/'])
        }
      });
  }

  getMovimientosObra(page = null) {
    this.liquidacionCapturaMovimientosObraService.getMovimientosObraByLiquidacion(this.idLiquidacion, page)
        .subscribe(response => {
          const content = response.json().content;
          this.movimientosObra = content.data;
          this.alterTable = (this.movimientosObra.length > 0)? false: 'not_result';
        }, (error) => {
          // se revisan errores 403 - 500
          this.helperService.httpGlobalError(error);
            
          if (error == 400) {
            console.log('getMovimientosObra - error 400 ' , error);
          }
        });
  }

  confirmSaveFondo() {
    this.confirmModal.open({
      'title': 'Guardar Fondo de ahorro',
      'description': ' ¿Desea guardar el fondo de ahorro correspondiente a la obra ' + this.liquidacionSelected.obras.nombreObra +  ' del mes de ' + this.liquidacionSelected.fecha_formated + '?',
      'callback': this.saveFondo
    })
  }

  saveFondo() {

    this.errors = [];
    this.errors = this.liquidacionCapturaService.validateFondo(this.fondoSelected);

    if (!$.isEmptyObject(this.errors)) {
      return false;
    }
    this.processing = true;
    this.liquidacionCapturaService.saveFondo(this.fondoSelected)
      .subscribe(response => {
        console.log('save fondo response ', response);
        this.successModal.open({
          'title': 'Fondo de ahorro guardado',
          'description': 'El fondo de ahorro de la obra ' + this.liquidacionSelected.obras.nombreObra +  ' del mes de ' + this.liquidacionSelected.fecha_formated + ' fue guardado con éxito.'
        });
        this.changing = false;
        this.processing = false;
        this.getLiquidacion();
      }, error => {
        console.log('save fondo error ', error);
        this.helperService.httpGlobalError(error, false);
        this.changing = true;
        this.processing = false;
        if (error == 400 || error == 500) {
          // usamos modal en vez de notification
          this.errorModal.open({
            'title': 'ERROR',
            'description': 'No se pudo completar la acción solicitada. Por favor, intente más tarde.'
          });
        }
      })
  }

  confirmSendLiquidacion() {
    this.confirmModal.open({
      'title': 'Liquidación',
      'description': 'Enviar a revisión <br/> ¿Desea enviar a revisión la Liquidación de ' + this.liquidacionSelected.obras.nombreObra +  ' del mes de ' + this.liquidacionSelected.fecha_formated + '?',
      'color': 'success',
      'text': 'Enviar',
      'callback': this.sendLiquidacion
    });
  }

  sendLiquidacion() {
    this.liquidacionCapturaService.sendLiquidacion(this.liquidacionSelected.idLiquidacion)
      .subscribe(response => {
        const content_response = response.json().content;
        this.helperService.notification('Liquidación Enviada', 'Se ha enviado a revisión la Liquidación de ' + this.liquidacionSelected.obras.nombreObra +  ' del mes de ' + this.liquidacionSelected.fecha_formated + '?', 'success');
        this.regresar()
      }, error => {
        console.log('error sendLiquidación ', error);
        this.helperService.httpGlobalError(error);
      })
  }

  confirmCancelChanges() {
    if (this.changing) {
      this.confirmModal.open({
        'title': 'Cancelar cambios',
        'description': '¿Está seguro de cancelar los cambios?',
        'callback': this.cancelChanges,
        'color': 'danger'
      });
    } else {
      this.cancelChanges();
    }
  }

  cancelChanges() {
    this.changing = false;
    this.startFondo();
  }

  confirmDeleteLiquidacion() {
    this.confirmModal.open({
      'title': 'Eliminar liquidación',
      'description': '¿Desea eliminar la liquidación ' + this.liquidacionSelected.obras.nombreObra +  ' del mes de ' + this.liquidacionSelected.fecha_formated + '?',
      'callback': this.deleteLiquidacion,
      'color': 'danger'
    });
  }
  deleteLiquidacion() {
    this.liquidacionCapturaService.deleteLiquidacion(this.idLiquidacion)
      .subscribe(response => {
        console.log('delete liq response ', response);
        this.helperService.notification('Liquidación eliminada', 'La liquidación ha sido eliminada.', 'success');
        this.regresar();
      }, error => {
        this.helperService.httpGlobalError(error);
      })
  }

  fotografiaSelectedWithId() {
    if (! this.fondoSelected) {
      return false;
    }

    return (this.fondoSelected.idLiquidacion_Imagenes);
  }

  regresar() {
    console.log('regresando a vista anterior');
    this.router.navigate(["/liquidacion-captura"]);
  }

  hasNotasRechazo() {
    return this.liquidacionSelected && this.liquidacionSelected.estado == 2 && this.liquidacionSelected.notasRechazo && this.canEdit();
  }

  hasMovimientos() {
    return this.liquidacionSelected && this.liquidacionSelected.movimientos > 0;
  }

  // MODAL FUNCTIONS

  modalCallback(callback){
    callback();
  }

  // MAIN SECTIONS FUNCTIONS

  mainContainerClass(){
    return (this.mostrarListado)?"col-12":"offset-2 col-8";
  }

  mainTableClass(){
    return (this.mostrarListado)?"col-8":"col-4";
  }

  mainDetailsClass(){
    return (this.mostrarListado)?"col-4":"col-8";
  }

  canEdit() {
    return (this.liquidacionSelected && this.liquidacionSelected.isDate && (this.liquidacionSelected.estado == 0 || this.liquidacionSelected.estado == 2));
  }

  writePermission() {
    return this.liquidacionCapturaService.writePermission();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/liquidacion-captura/liquidacion-captura-fondo-ahorro/liquidacion-captura-fondo-ahorro.component.ts